<div class="card-row">
  <div class="container-row">
    <div class="row-main">
      <div class="section-left">
        <div class="container-flex-fit">
          <div class="container-img">
            <!--
              <span style="border-radius: 7px; padding: 5px; font-weight: bold; font-size: small; width: 100%;" *ngIf="offer.pictures.length < 1">
                {{'UserPages.UserExportOffers.NotAvailablePictureLabel' | translate}}
              </span>
            -->
            <img loading="lazy" [src]="getIconUrl(offer.exportOffer.variety.urlIcon) | speciesImageUrl" style="border-radius: 7px; width: 100%; max-width: 50px; height: auto;" alt="" *ngIf="offer.exportOffer.variety.urlIcon"/>
            <span class="material-symbols-outlined" style="font-size:40px;opacity:.3;color:#8C2B87" *ngIf="!offer.exportOffer.variety.urlIcon">
              no_photography
            </span>
          </div>
          <div class="container-variety">
            <h2 class="text-main" style="font-size: medium;" >{{offer.exportOffer.variety.species | speciesName}}</h2>
            <!-- <span style="text-transform: uppercase; font-size: medium;">{{offer.exportOffer.variety.name}}</span> -->
            <span style="font-weight: bolder; color: #8c2b87; font-size: small;">{{'UserPages.UserClosedSale.programText' | translate}} ID: {{offer.directSalePrograms[0].id}} </span>

          </div>
        </div>

        <div class="container-flex-fit">
          <div class="flex align-items-center justify-content-center" *ngIf="offer.directSalePrograms[0].type === 0">
            <img  loading="lazy" style="width: auto; height: 24px;" alt="" src="../../../../assets/img/container_icon_2.png" >
            <span style="font-size: small; font-weight: bold; margin-left: 5px;">{{offer.directSalePrograms[0].containers }} </span>
          </div>
          <div class="flex align-items-center justify-content-center" *ngIf="offer.directSalePrograms[0].type === 1">
            <span class="material-symbols-outlined" style="color: #8c2c85;">pallet</span>
            <span style="font-size: small; font-weight: bold; margin-left: 5px;">{{offer.directSalePrograms[0].palletsPerWeek * getTotalWeekRow(offer.directSalePrograms[0]) }} </span>
          </div>
        </div>

        <div class="container-flex-fit">
          <div class="flex align-items-center justify-content-end">
            <div class="container-importer">
              <div class="container-icon-label">
                <span class="material-symbols-outlined info-icon" style="font-size: 17px; margin-top: 2px;">
                  person
                </span>
                <span class="info-text-program-label">
                  Importer:
                </span>
              </div>
              <span style="font-weight: bolder; color: #8c2b87; font-size: small; height: auto; margin-left: 10px" >
                <app-text-preview-tooltip
                  [text]="offer.directSalePrograms[0].importerCompanyName"
                  [maxWidth]="200"
                  >
                </app-text-preview-tooltip>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="section-right" >
        <div class="container-flex-between">
          <!-- <div class="flex justify-content-start align-items-center container-flex-full">
            <img [flag]="offer.exportOffer.country?.code" height="50px" alt=""/>
            <div class="flex flex-column" style="margin-left: 10px;">
              <span style="font-weight: bolder; font-size: small;">{{offer.exportOffer.country?.name}}</span>
               <span style="font-size: small;">{{'UserPages.UserClosedSale.ProductDetail.OriginPortText' | translate}} (?)</span>
            </div>
          </div> -->
          <app-location-info
          [showLocationName]="false"
          [type]="offer.directSalePrograms[0].type"
          [countryName]="offer.exportOffer.country?.name"
          [countryCode]="offer.exportOffer.country?.code"
          >

          </app-location-info>
          <!-- <div class="container-nave"> -->

            <!-- <span class="material-symbols-outlined" style="color: #6da043;" *ngIf="offer.directSalePrograms[0].type === 0">directions_boat</span>
            <span class="material-symbols-outlined" style="color: #6da043;" *ngIf="offer.directSalePrograms[0].type === 1">flight</span>
            <span class="material-symbols-outlined" style="color: #6da043;">arrow_forward_ios</span> -->
            <app-transport-type-icon [type]="offer.directSalePrograms[0].type"></app-transport-type-icon>
          <!-- </div> -->
          <app-location-info
          [showLocationName]="false"
          [type]="offer.directSalePrograms[0].type"
          [countryName]="offer.directSalePrograms[0].destinationCountry.name"
          [countryCode]="offer.directSalePrograms[0].destinationCountry.code"
          [portName]="offer.directSalePrograms[0].dischargePort.name"
          [airportName]="offer.directSalePrograms[0].airport?.name"
          [cityName]="offer.directSalePrograms[0].city?.name"
          ></app-location-info>
        </div>

          <div class="container-btn-detail">
            <button pButton class="btns-text btn-main" (click)="setVisibleOrderDetail(offer)">

              {{'UserPages.UserClosedSale.ProgramDetailBtn' | translate}}
            </button>
          <div>

          </div>
        </div>
      </div>
    </div>

  </div>
  <div  *ngIf="offer.expanded" class="container-expanded">


    <div class="column-expanded-left">
      <div class="section-title">
        <span class="">{{'UserPages.UserClosedSale.ProductDetailText' | translate}}</span>
      </div>
      <div class="flex">
        <div class="column-info-fit">
          <div class="row-info">
            <span class="material-symbols-outlined info-icon">
              pallet
              </span>
            <span class="info-text">
              {{'UserPages.UserClosedSale.ProductDetail.CasePerPalletsText' | translate}}:
              {{offer.exportOffer.caseQuantityPerPallet}}
            </span>
          </div>
          <div class="row-info">
            <span class="material-symbols-outlined info-icon" >
              weight
              </span>
              <span class="info-text">
                {{'UserPages.UserClosedSale.ProductDetail.NetKilosText' | translate}}:
                {{offer.exportOffer.netKilos ? offer.exportOffer.netKilos + ' kg' : '-' }}
              </span>
          </div>
          <div class="row-info" *ngIf="offer.directSalePrograms[0].type === 0">
            <img loading="lazy" class="info-icon" style="width: 100%; max-width: 25px; height: 20px;" alt="" src="../../../../assets/img/container_icon_2.png" >
              <span class="info-text">
                {{'UserPages.UserClosedSale.ProductDetail.ProgramContainersText' | translate}}:
                {{offer.directSalePrograms[0].containersPerWeek ?  offer.directSalePrograms[0].containersPerWeek : '-'}}
              </span>
          </div>
          <div class="row-info" *ngIf="offer.directSalePrograms[0].type === 1">
            <span class="material-symbols-outlined info-icon">
              pallet
              </span>
              <span class="info-text">
                {{'UserPages.UserClosedSale.ProductDetail.ProgramPalletsText' | translate}}:
                {{offer.directSalePrograms[0].palletsPerWeek ?  offer.directSalePrograms[0].palletsPerWeek : '-'}}
              </span>
          </div>
          <div class="row-info">
            <span class="material-symbols-outlined info-icon" >
              date_range
              </span>
            <span class="info-text">
              {{'UserPages.UserClosedSale.ProductDetail.WeekNumberText' | translate}}:
              {{getTotalWeekRow(offer.directSalePrograms[0]) }}
            </span>
          </div>
          <div class="row-info">
            <span class="material-symbols-outlined info-icon">
              calendar_month
            </span>
            <span class="info-text">
              {{'UserPages.UserClosedSale.ProductDetail.ProgramNameText' | translate}}:
              {{offer.directSalePrograms[0].name ?? ' -'}}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="flex-1"></div>

    <div class="column-expanded-left pl-3">
      <div class="section-title">
        <span style="opacity:0">.</span>
      </div>

      <div class="flex">
        <div class="column-info-fit">
          <div class="row-info">
            <div class="flex align-items-center">
              <span class="material-symbols-outlined info-icon">science</span>
              <span class="info-text">
                {{'UserPages.UserClosedSale.ProductDetail.QualityControlCriteriaText' | translate}}:
                {{getIncludedLabel(offer.exportOffer.isQualityControl)}}
                <p-button *ngIf="offer.exportOffer?.qualityDocuments?.length" (onClick)="getExportOfferQualityDocument(offer.exportOffer.qualityDocuments)" pTooltip="{{'UserPages.UserExportOffers.EditExportOffer.ViewQualityDocument' | translate}}" [style]="{ 'margin': 0, 'padding': 0 }" icon="pi pi-file-pdf" styleClass="p-button-link p-button-lg"></p-button>
              </span>
            </div>
          </div>
          <div class="row-info">
            <span class="material-symbols-outlined info-icon">
              inventory_2
              </span>
              <span class="info-text flex">
                {{'UserPages.UserClosedSale.ProductDetail.BoxTypeText' | translate}}:

              </span>
              <span class="info-text flex">
                <app-text-preview-tooltip
                  [text]="offer.exportOffer.caseSize ? offer.exportOffer.caseSize  : '-'"
                  [maxWidth]="100"
                  >
              </app-text-preview-tooltip>
              </span>
          </div>
          <div class="row-info">
            <span class="material-symbols-outlined info-icon" >
              paid
              </span>
            <span class="info-text">
              {{'UserPages.UserClosedSale.ProductDetail.PaymentMethodText' | translate}}:
              {{offer.exportOffer.paymentAgainstBL + '%' + '/' + offer.exportOffer.typeSale }}
            </span>
          </div>
          <div class="row-info">
            <span class="material-symbols-outlined info-icon" >
              paid
              </span>
            <span class="info-text">
              {{'UserPages.UserClosedSale.ProductDetail.PriceText' | translate}}:
              {{offer.exportOffer.listPrice | currency: 'USD':'US$'}}/{{offer.exportOffer.typeSale}}

            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="flex-1"></div>

    <div class="" style="padding:0 1em;">
      <div class="">
        <div class="section-title">
          <span class="">{{'UserPages.UserClosedSale.ProductDetailText' | translate}}</span>
        </div>
        <div *ngIf="profile?.type == 1" class="flex flex-row align-items-center pb-2">
          <span class="material-symbols-outlined info-icon" style="font-size: 17px; margin-top: 3px;">
            person
          </span>
            <span class="info-text-program">
              Importer:
            </span>
            <span class="program-info">
              <app-text-preview-tooltip
              [text]="offer.directSalePrograms[0].importerCompanyName"
              [maxWidth]="200"
              >
            </app-text-preview-tooltip>
            </span>
        </div>
        <div *ngIf="profile?.type == 2" class="flex flex-row align-items-center pb-2">
          <span class="material-symbols-outlined info-icon" style="font-size: 17px; margin-top: 3px;">
            person
          </span>
            <span class="info-text-program">
              Exporter:
            </span>
            <span class="program-info">
              <app-text-preview-tooltip
              [text]="offer.exportOffer.exporter.companyName"
              [maxWidth]="200"
              >
            </app-text-preview-tooltip>
            </span>
        </div>
        <div class="flex flex-row align-items-center pb-2">
          <span class="material-symbols-outlined info-icon" style="font-size: 17px; margin-top: 3px;">
            person
          </span>
            <span class="info-text-program">
              Consignee:
            </span>
            <span class="program-info">
              <app-text-preview-tooltip
                [text]="offer.directSalePrograms[0].consigneeCompanyName ?? '-'"
                [maxWidth]="200"
                >
              </app-text-preview-tooltip>
            </span>
        </div>
        <div class="flex flex-row align-items-center pb-2">
          <span class="material-symbols-outlined info-icon" style="margin-top: 3px;">
            person
          </span>
            <span class="info-text-program">
              Notify:
            </span>
            <span class="program-info">
              <app-text-preview-tooltip
                [text]="offer.directSalePrograms[0].notifyCompanyName ?? '-'"
                [maxWidth]="200"
                >
              </app-text-preview-tooltip>
            </span>
        </div>
      </div>
    </div>

    <div class="flex-1"></div>

    <div class="week-column">
      <div class="section-title">
        <span class="">{{'UserPages.UserClosedSale.week/yearText' | translate}}</span>
      </div>

          <div class="flex flex-column">
            <div class="flex flex-column xl:flex-row flex-wrap line-height-1 justify-content-start gap-1" style="padding: 0 0 .5em">
              <div class="flex align-items-center">
                <span class="material-symbols-outlined info-icon">
                  calendar_today
                </span>
                <span class="info-text-program">
                  {{'UserPages.UserClosedSale.FromProgramText' | translate}}:
                </span>
              </div>
              <div class="flex align-items-center">
                <span class="date-info">
                  {{offer.directSalePrograms[0].startWeek}} / {{offer.directSalePrograms[0].startWeekYear}}
              </span>
              </div>
            </div>
            <div class="flex flex-column xl:flex-row flex-wrap line-height-1 justify-content-start gap-1">
              <div class="flex align-items-center">
                <span class="material-symbols-outlined info-icon">
                  calendar_today
                </span>
                <span class="info-text-program">
                  {{'UserPages.UserClosedSale.ToProgramText' | translate}}:
                </span>
              </div>
              <div class="flex align-items-center">
                <span class="date-info">
                  {{offer.directSalePrograms[0].endWeek}} / {{offer.directSalePrograms[0].endWeekYear}}
              </span>
              </div>
            </div>
            <div>
              <div style="margin-top: 10px;">
                <button class="btn-icon w-full" pButton pTooltip="{{'DirectSaleActions.ViewProgramText' | translate}}" styleClass="p-button-primary p-button-sm" (click)="goToDirectSaleProgramOrders(offer.directSalePrograms[0].guid)">
                  <span class="material-symbols-outlined hidden xl:block" style="font-size:15px;">
                    visibility
                  </span>
                  <span class="line-height-1 ml-0 xl:ml-3 block xl:hidden">
                    {{'UserPages.UserClosedSale.ProgramTitle' | translate}}
                  </span>
                  <span class="line-height-1 ml-3 hidden xl:block">
                    {{'UserPages.UserClosedSale.ProgramBtn' | translate}}
                  </span>
                </button>
              </div>
              <div style="margin-top: 10px;">
                <button class="btn-icon w-full" pButton
                  pTooltip="{{'AssignStock.AssignPalletTitle' | translate}}"
                  styleClass="p-button-primary p-button-sm" (click)="showAssign(offer.directSalePrograms[0].guid)">
                  <span class="material-symbols-outlined hidden xl:block" style="font-size:15px;">
                    edit
                  </span>
                  <span class="line-height-1 ml-0 xl:ml-3">
                    {{'AssignStock.AssignPalletTitle' | translate}}
                  </span>
                </button>
              </div>
              <div style="margin-top: 10px;">
                  <button class="btn-icon w-full" pButton
                  pTooltip="{{'AssignStock.EditPalletTitle' | translate}}"
                  styleClass="p-button-primary p-button-sm" (click)="showEdit(offer.directSalePrograms[0].guid)">
                  <span class="material-symbols-outlined hidden xl:block" style="font-size:15px;">
                    edit
                  </span>
                  <span class="line-height-1 ml-0 xl:ml-3">
                    {{'AssignStock.EditPalletTitle' | translate}}
                  </span>
                </button>
              </div>
            </div>
          </div>
    </div>

    <div class="flex-1"></div>

    <div class="container-flex-fit pd-right-0 xl:pd-left">
      <div class="flex flex-column">
        <div class="flex justify-content-end" pTooltip="{{'DirectSaleActions.ViewActionText' | translate}}"  tooltipPosition="bottom">
          <p-menu #menuView [model]="this.menuViewItems" [popup]="true" appendTo="body"/>
              <a class="round-icon view-icon" (click)="menuView.toggle($event)">
                <span class="material-symbols-outlined">
                  visibility
                </span>
              </a>
        </div>
        <div *ngIf="profile?.type == 1" class="flex justify-content-end" pTooltip="{{'DirectSaleActions.EditActionText' | translate}}"  tooltipPosition="bottom">
            <p-menu #menuEdit [model]="this.menuEditItems" [popup]="true" appendTo="body"/>
            <a class="round-icon edit-icon"  (click)="menuEdit.toggle($event)">
              <span class="material-symbols-outlined">
                edit
              </span>
            </a>
        </div>
        <div *ngIf="profile?.type == 1" class="flex justify-content-end" pTooltip="{{'DirectSaleActions.CopyActionText' | translate}}"  tooltipPosition="bottom" >
          <p-menu #menuCopy [model]="this.menuCopyItems" [popup]="true" appendTo="body"/>
          <a class="round-icon edit-icon"  (click)="menuCopy.toggle($event)">
            <span class="material-symbols-outlined" >
              file_copy
            </span>
          </a>
        </div>
        <div *ngIf="profile?.type == 1" class="flex justify-content-end" pTooltip="{{'DirectSaleActions.DeleteActionText' | translate}}"  tooltipPosition="bottom">
          <p-menu #menuDelete [model]="this.menuDeleteItems" [popup]="true" appendTo="body"/>
          <a class="round-icon delete-icon" (click)="menuDelete.toggle($event)">
            <span class="material-symbols-outlined">
              delete
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
